import React, { Component } from "react";
import auth from "../services/authService";
import { Link } from "react-router-dom";
class AdminMenu extends Component {
  state = {};

  render() {
    if (auth.IsAdmin()) {
      return (
        <div>
          <Link to="/admin">Manage Ideas</Link> |{" "}
          <Link to="/adminusers">Manage Users</Link>
        </div>
      );
    } else return "";
  }
}

export default AdminMenu;
